<template>
  <div class="login">
    <div class="login-img">
      <span><img :src="require(`@/assets/logo/xuchang2.png`)" alt=""> </span>
    </div>
    <div class="apply-form">
      <div class="applyBox">
        <p class="apply-title">
          学 校 申 请
        </p>
        <el-form
          ref="info"
          class="forms"
          :model="info"
          label-width="130px"
          label-position="right"
          :rules="rules"
          status-icon
        >
          <el-form-item label="所属区：" prop="area_id">
            <el-select v-model="info.area_id" placeholder="请选择">
              <el-option
                v-for="(item, index) in option"
                :key="index"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="学校名称：" prop="school_name">
            <el-input
              v-model="info.school_name"
              placeholder="请输入学校全称"
            />
          </el-form-item>
          <el-form-item label="联系人：" prop="name">
            <el-input
              v-model="info.name"
              placeholder="请输入联系人姓名"
            />
          </el-form-item>
          <el-form-item label="手机号：" prop="phone">
            <el-input
              v-model="info.phone"
              type="number"
              auto-complete="off"
              placeholder="请输入您的手机号"
              clearable
            />
          </el-form-item>
          <el-form-item label="图形验证码：" class="btn4" prop="captcha">
            <el-input
              v-model="info.captcha"
              type="smsCheck"
              auto-complete="off"
              placeholder="请输入图形验证码"
              clearable
            />
            <el-button type="text">
              <img :src="imgUrl" alt="" @click="handleCheckImg">
            </el-button>
          </el-form-item>
          <el-form-item label="验证码：" prop="code" class="btn4">
            <el-input
              v-model="info.code"
              type="smsCheck"
              auto-complete="off"
              placeholder="请输入您的验证码"
              clearable
            />
            <el-button
              :disabled="info.phone.length != 11 || isSendCode"
              class="btn3"
              @click="getVerificationCode"
            >
              {{ codeText }}
            </el-button>
          </el-form-item>

          <el-button
            type="primary"
            class="btn1"
            :loading="logining"
            @click="handleSubmit"
          >
            立即申请
          </el-button
          >
          <div class="denglu">
            已有帐号？直接<span
              class="zhuce" @click="handleRegester"
            >登录</span
            >
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script src="https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js"></script>
<script>
import api from "@/api/app";
import mock from "@/utils/mock";
import { setTokenExp } from "@/utils/auth";
export default {
  components: {},
  data() {
    return {
      option: [],
      value: "",
      value1: [],
      value2: [],
      value3: [],
      dialogVisible: false,
      urltest: "",
      systemInfo: mock.system.login.viewInfo,
      systemInit: mock.system.login.init,
      logining: false,
      isSendCode: false,
      codeText: "获取验证码",
      imgUrl: null,
      info: {
        phone: "",
        code: "",
        school_name: "",
        name: "",
        area_id: "",
        captcha:''
      },
       rules: {
          area_id: [
            { required: true, message: '请选择所属区', trigger: 'blur' }
          ],
          school_name: [
            { required: true, message: '请输入学校名称', trigger: 'blur' }
          ],
          name: [
            { required: true, message: '请输入联系人姓名', trigger: 'blur' }
          ],
           phone: [
            { required: true, message: '请输入手机号', trigger: 'blur' }
          ],
            captcha: [
            { required: true, message: '请输入图形验证码', trigger: 'blur' }
          ],
          code: [
            { required: true, message: '请输入验证码', trigger: 'blur' }
          ]
        },
      info1: {
        phone: null,
        captcha: null,
        key: null,
      },
    };
  },

  created() {
    this.handleCheckImg();
    let _this = this;
    document.onkeydown = function(e) {
      var key = window.event.keyCode;
      if (key == 13) {
        _this.handleSubmit();
      }
    };
  },
  mounted() {
    this.handleoptionList();
  },
  methods: {
    handleoptionList() {
      var obj = {};
      obj.parent_id = 410100;
      api.system.areas(obj).then((res) => {
        this.option = res.data;
      });
    },
    handleRegester() {
      this.$router.push({
        path: "/login",
      });
    },
    to222form() {
      this.isShow = false;
    },
    toQrCode() {
      this.isShow = true;
      this.handleWxLogin();
    },
    handleWxLogin() {
      this.dialogVisible = true;
      // let obj = await this.systemInit.handleWxLogin();
      let obj1 = {};
      obj1.type = 2;
      api.system.wx(obj1).then((res) => {
        let APPID = res.data.appid;
        let REDIRECT_URI = res.data.redirect_uri;
        let STATE = res.data.state;
        this.urltest = `https://open.weixin.qq.com/connect/qrconnect?appid=${APPID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=snsapi_login&state=${STATE}#wechat_redirect`;
        var obj = new WxLogin({
          self_redirect: false,
          id: "login_container",
          appid: APPID,
          scope: "snsapi_login",
          redirect_uri: REDIRECT_URI,
          state: STATE,
          style: "black",
        });
      });
    },
    async handleCheckImg() {
      let obj = await this.systemInit.handleCheckImg();
      this.imgUrl = obj.img;
      this.info1.key = obj.key;
    },
    getVerificationCode() {
      this.info1.phone = this.info.phone;
      this.info1.captcha = this.info.captcha
      if (this.info1.captcha) {
        api.system.sendSms(this.info1).then(() => {
          this.$message({
            message: "验证码已发送",
            type: "success",
          });
          this.countDown(60);
        }).catch(()=>{
          this.handleCheckImg()
        })
      } else {
        this.$message({
          message: "请正确填写图片验证码",
          type: "error",
        });
      }
    },
    countDown(time) {
      if (time === 0) {
        this.isSendCode = false;
        this.codeText = "获取验证码";
        return;
      } else {
        this.isSendCode = true;
        this.codeText = "重新发送(" + time + ")";
        time--;
      }
      setTimeout(() => {
        this.countDown(time);
      }, 1000);
    },
    async handleSubmit() {
        this.$refs.info.validate((valid) => {
          if (valid) {
            this.logining = true;
                api.system.apply(this.info).then((res) => {
            this.$message({
              message: "申请已提交，请等待管理员审核与您联系！",
              type: "success",
            });

        setTimeout(() => {
          this.$router.push({ path: "/login" });
        }, 1000);
      }).catch(()=>{
        this.logining = false
        this.handleCheckImg()
      })
          } else {
            console.log('error submit!!');
            return false;
          }
        });

    },
    handleRoute(v) {
      this.$router.push(v);
    },
  },
  watch: {
    'info.phone':{
      handler(val){
        // console.log(split(''))
        if(val.length>=11){
          // this.info.phone=vals.split('')
          this.info.phone=val.substring(0,11)
          console.log(this.info.phone)
        }
      },
      deep:true
    }
  },
};
</script>

<style scoped lang="scss">
.denglu {
  margin-top: 30px;
  text-align: center;
}
.apply-form {
  // width: 85%;
  // width:700px;
  // // height: 75%;
  // background-color: #fff;
  // border-radius: 30px;
  // position: fixed;
  // top: 52%;
  // left: 50%;
  // transform: translate(-50%, -50%);

  // .forms {
  //   width: 500px;
  //   margin: 0 auto;
  //   height: 80%;
  // }
}
.btn3 {
  border-radius: 30px !important;
  color: #5282f0;
  border-color: #5282f0;
}
.btn1 {
  margin-top: 40px;
  width: 100%;
  height: 53px;
  background-image: linear-gradient(24deg, #5f8cf4 0%, #5181ef 100%),
    linear-gradient(#2eae3d, #2eae3d);
  background-blend-mode: normal, normal;
  box-shadow: 0px 10px 19px 2px rgba(82, 130, 240, 0.24);
  border-radius: 26px;
  border: 0;
  color: #ffffff;
  font-family: "Adobe Heiti Std";
  font-size: 18px;
  text-align: center;
}
.login {
  display: flex;
  overflow: hidden;
  height: 100%;
  width: 100%;
  background: url("../../../assets/bg/bg-system1.png") no-repeat;
  background-size: 100% 100%;
    min-width: $xr-min-width;
    display: flex;
  &-img {
    width: 50%;
    height: 100%;
    // padding: 5.19% 0 25% 7.93%;
    padding: 2.46% 0 0 3.8%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
  }
  .apply-form {
    // width: 28.89%;
    // width: 90%;

    // height: 75%;
    // width: 700px;
    flex: 1;
    height: 100%;
      display: flex;
    justify-content: center;
    align-items: center;

    .applyBox{
      background: #fff;
      width: 800px;
      padding: 20px;
      border-radius: 30px;
     display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-right: 60px;
    .apply-title {
    font-size: 24px;
    color: #333333;
    font-family: "Adobe Heiti Std";
    text-align: center;
    margin: 3% 0;
    // margin-left: 85px;
  }
    }
      .other {
        text-align: center;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        > div > div:nth-child(1) {
          font-family: Adobe HeitiStd;
          font-size: 14px;
          color: #888888;
        }
      }
    }
  }

</style>
<style scoped lang="scss">
.login-form /deep/.el-form-item {
  margin-bottom: 26px;
}
.login-form /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 0;
  width: 100%;
  height: 55px;
  @include fun-border(0, "bottom");
}
.btn4 /deep/ .el-form-item__content {
  display: flex;
  > div {
    width: 60%;
    margin-right: 10%;
  }
  button {
    padding: 0;
    width: 30%;
    border-radius: 6px;
    img {
      height: 55px;
      width: 100%;
    }
  }
}
.zhuce {
  color: #2f82ff;
  cursor: pointer;
}
.login-form /deep/ .el-form-item__error {
  left: 15px;
}
.btn3 /deep/ .el-button:focus,
.el-button:hover {
  background-color: #ecf5ff;
}
.el-select {
  width: 100%;
}
.login /deep/ .btn4{
  .el-form-item__content{
    button{
      img{
        height: 40px;
      }
    }
  }
}
</style>
